export default __webpack_public_path__ + "static/media/wifi_medium_white.aa2c698f.png";